export interface I18nTranslateContext {
  t: (key: string) => string;
  te: (key: string) => boolean;
}

function normalizeKey(rawKey: unknown): string {
  return typeof rawKey === 'string' ? rawKey.trim() : '';
}

export function translateOrValue(i18n: I18nTranslateContext, rawKey: unknown): string {
  const key = normalizeKey(rawKey);
  if (!key) return '';
  return i18n.te(key) ? i18n.t(key) : key;
}

export function translatePrefixedOrValue(
  i18n: I18nTranslateContext,
  prefix: string,
  rawKey: unknown,
): string {
  const key = normalizeKey(rawKey);
  if (!key) return '';

  const normalizedPrefix = normalizeKey(prefix);
  if (!normalizedPrefix) return key;

  const translationKey = `${normalizedPrefix}.${key}`;
  return i18n.te(translationKey) ? i18n.t(translationKey) : key;
}
